'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('./FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultElements = {
  wrapper: 'span'
};

function createElement(elements, type) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return _react2.default.createElement.apply(_react2.default, [elements && elements[type] || defaultElements[type] || defaultElements.wrapper].concat(args));
}

var FormattedJSXMessage = function FormattedJSXMessage(props) {
  var fn = _I18n2.default.lookup(props.message);
  if (fn === undefined || fn === null) {
    return _react2.default.createElement(
      'span',
      null,
      _I18n2.default.missingTranslation(props.message, props.options)
    );
  }

  var count = props.options && props.options.count;
  var countIsSet = _I18n2.default.isSet(count);

  if ((typeof fn === 'undefined' ? 'undefined' : _typeof(fn)) === 'object' && countIsSet) {
    var pluralizer = _I18n2.default.pluralization.get();
    var keys = pluralizer(count);

    while (keys.length) {
      var key = keys.shift();
      if (_I18n2.default.isSet(fn[key])) {
        fn = fn[key];
        break;
      }
    }
  }

  var formattedProps = _extends({}, props.options);
  if (countIsSet && typeof count === 'number') {
    formattedProps.count = _I18n2.default.formatNumber(count);
  } else if (typeof fn === 'string') {
    console.warn('I18n: FormattedJSXMessage called with non-JSX message key ' + props.message + '. See go/i18n-react for more info. ');
    return _react2.default.createElement(_FormattedMessage2.default, { message: props.message, options: props.options });
  }

  return fn(createElement, props.elements, formattedProps);
};

FormattedJSXMessage.propTypes = {
  message: _react.PropTypes.string.isRequired,
  elements: _react.PropTypes.object.isRequired,
  options: _react.PropTypes.object,
  jsxMessageValidator: function jsxMessageValidator(props, propName, componentName) {
    if (!props.message.endsWith('_jsx')) {
      console.warn('I18n: ' + componentName + ' called with invalid message prop not ending in _jsx for ' + props.message);
    }
  }
};

exports.default = FormattedJSXMessage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.327/js/components/FormattedJSXMessage.js
// module id = 1077
// module chunks = 2 3